import { render } from "./ShopManagement.vue?vue&type=template&id=2f4e4ff0&scoped=true"
import script from "./ShopManagement.vue?vue&type=script&lang=js"
export * from "./ShopManagement.vue?vue&type=script&lang=js"

import "./ShopManagement.vue?vue&type=style&index=0&id=2f4e4ff0&lang=scss"
import "./ShopManagement.vue?vue&type=style&index=1&id=2f4e4ff0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4e4ff0"]])

export default __exports__